import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { FinanceService } from '../services/finance.service';
import { FinanceIncident } from '../models/finance-incident.model';
import { IncidentLandCategoryType } from '../models/incident-land-category-type.model';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentService } from '../services/incident.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../incident-modal.component';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './finance-modal.html'
})

export class FinanceModalComponent extends IncidentModalComponent<FinanceIncident> {
    private service: FinanceService;

    public selectedLandCategory: IncidentLandCategoryType;

    constructor(location: PlatformLocation,
        fb: UntypedFormBuilder,
        service: FinanceService,
        typeService: IncidentTypeService,
        public incidentService: IncidentService,
        public dialogRef: MatDialogRef<IncidentModalComponent<FinanceIncident>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<FinanceIncident>,
        modalService: MvdModalService,
        prohibitionService: ProhibitionService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.service = service;
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: FinanceIncident, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;
        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        this.service.saveIncident(this.data.incident).subscribe(r => {}, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
